'use strict';

var I18N = require('utils/i18n');
var SharedData = require('shared_data.generated');

var Consts = {};

Consts.DeviceTypeText = {};
Consts.DeviceCategory = {};

Consts.pluginStates = {
    READY: 'ready',
    NOT_LOADED: 'not_loaded',
    NOT_DEFINED: 'not_defined',
    BROKEN: 'broken',
};

Consts.GroupReqMode = {
    Standard: '',
    User: 'user',
    CompanyDefault: 'default',
    Filter: 'filter',
};

Consts.FieldInfo = {
    Numeric: ['alarm_count', 'station', 'address', 'status'],
    Date: ['registered', 'last_seen'],
    NoFilter: ['category', 'tags', 'groups', 'parent', 'wired_to'],
    NoColumn: ['category', 'parent', 'tags'],
    NoUserGroup: ['category', 'parent', 'MBR_101', 'MBR_100', 'groups'],
    NoReport: ['tags', 'groups', 'parent', 'wired_to', 'filter'],
};

// from-backend

// MinimumWeatherTransferFreq smallest amount of seconds between two weather requests
Consts.MinimumWeatherDataTransferFreq = 900;

Consts.TransferMode = {
    None: 0,
    Value: 1,
    Weather: 2,
};

Consts.FieldGroup = {
    Device: 1,
    Meta: 2,
    Data: 3,
};

Consts.DisplayType = {
    Graphic: 1,
    Symbol: 2,
};

Consts.Feelers = [
    'AF1',
    'AF2',
    'VF1',
    'VF2',
    'VF3',
    'VF4',
    'RF1',
    'RF2',
    'RF3',
    'RüF1',
    'RüF2',
    'RüF3',
    'SF1',
    'SF2',
    'SF3',
];

Consts.Pumps = ['UP1', 'UP2', 'UP3', 'UP4', 'UP5', 'ZP', 'SLP', 'CP', 'TLP'];

Consts.Valves = ['RK1', 'RK2', 'RK3'];

Consts.SchemaElementsToDataPoint = {
    AF1: 'MBR_10', // MbRegAF1
    AF2: 'MBR_11', // MbRegAF2
    FestwertNachtHK1: 'MBR_1043', // MbRegFestwertNachtHK1
    FestwertNachtHK2: 'MBR_1243', // MbRegFestwertNachtHK2
    FestwertNachtHK3: 'MBR_1443', // MbRegFestwertNachtHK3
    FestwertTagHK1: 'MBR_1042', // MbRegFestwertTagHK1
    FestwertTagHK2: 'MBR_1242', // MbRegFestwertTagHK2
    FestwertTagHK3: 'MBR_1442', // MbRegFestwertTagHK3
    NachtsollwertHK1: 'MBR_1004', // MbRegNachtsollwertHK1
    NachtsollwertHK2: 'MBR_1204', // MbRegNachtsollwertHK2
    NachtsollwertHK3: 'MBR_1404', // MbRegNachtsollwertHK3
    RF1: 'MBR_20', // MbRegRF1
    RF1_s: 'MBR_1005', // MbRegRaumsollwertHK1
    RF2: 'MBR_21', // MbRegRF2
    RF2_s: 'MBR_1205', // MbRegRaumsollwertHK2
    RF3: 'MBR_22', // MbRegRF3
    RF3_s: 'MBR_1405', // MbRegRaumsollwertHK3
    RK1: 'MBR_107', // MbRegStellsignalHK1
    RK2: 'MBR_109', // MbRegStellsignalHK2
    RK3: 'MBR_111', // MbRegStellsignalHK3
    RüF1: 'MBR_17', // MbRegRueF1
    RüF1_s: 'MBR_1033', // MbRegRuecklaufsollwertHK1
    RüF2: 'MBR_18', // MbRegRueF2
    RüF2_s: 'MBR_1233', // MbRegRuecklaufsollwertHK2
    //	'RüF2_s':           'MBR_1828',   // MbRegRuecklaufsollwertWW
    RüF3: 'MBR_19', // MbRegRueF3
    RüF3_s: 'MBR_1433', // MbRegRuecklaufsollwertHK3
    SF1: 'MBR_23', // MbRegSF1
    SF1_s: 'MBR_1808', // MbRegSollwertLesenWW
    SF2: 'MBR_24', // MbRegSF2
    SF2_s: 'MBR_1808', // MbRegSollwertLesenWW
    SF3: 'MBR_25', // MbRegSF3
    TagsollwertHK1: 'MBR_1003', // MbRegTagsollwertHK1
    TagsollwertHK2: 'MBR_1203', // MbRegTagsollwertHK2
    TagsollwertHK3: 'MBR_1403', // MbRegTagsollwertHK3
    VF1: 'MBR_12', // MbRegVF1
    VF1_s: 'MBR_1000', // MbRegVorlaufsollwertHK1
    VF2: 'MBR_14', // MbRegVF2
    VF2_s: 'MBR_13', // MbRegVorlaufMischerSoll
    //	'VF2_s':            'MBR_1200',   // MbRegVorlaufsollwertHK2
    VF3: 'MBR_15', // MbRegVF3
    VF3_s: 'MBR_1400', // MbRegVorlaufsollwertHK3
    VF4: 'MBR_16', // MbRegVF4

    AF1_e: 'MBC_88', // MbCoilEbeneAF1
    CP: 'MBC_71', // MbCoilCP
    CP_e: 'MBC_106', // MbCoilEbeneCP
    RK1_e: 'MBC_90', // MbCoilEbeneStellsignalHK1
    RK2_e: 'MBC_92', // MbCoilEbeneStellsignalHK2
    RK3_e: 'MBC_94', // MbCoilEbeneStellsignalHK3
    SLP: 'MBC_60', // MbCoilSLP
    SLP_e: 'MBC_99', // MbCoilEbeneSLP
    TLP: 'MBC_70', // MbCoilTLP
    TLP_e: 'MBC_105', // MbCoilEbeneTLP
    UP1: 'MBC_57', // MbCoilUP1
    UP1_e: 'MBC_96', // MbCoilEbeneUP1
    UP2: 'MBC_58', // MbCoilUP2
    UP2_e: 'MBC_97', // MbCoilEbeneUP2
    UP3: 'MBC_59', // MbCoilUP3
    UP3_e: 'MBC_98', // MbCoilEbeneUP3
    ZP: 'MBC_61', // MbCoilZP
    ZP_e: 'MBC_100', // MbCoilEbeneZP
};

Consts.Category = {};

Consts.FieldSortOrder = {
    addr_street: '01',
    addr_number: '02',
    addr_city: '03',
    addr_code: '04',
    addr_country: '05',

    ctct_name: '06',
    ctct_phone: '07',
    ctct_email: '08',
};

Consts.MetaTableColumns = [
    { id: '#_addr_street', name: 'Straße' }, // I18N.TR('Straße')
    { id: '#_addr_number', name: 'Nummer' }, // I18N.TR('Nummer')
    { id: '#_addr_code', name: 'PLZ' }, // I18N.TR('PLZ')
    { id: '#_addr_city', name: 'Stadt' }, // I18N.TR('Stadt')
    { id: '#_addr_country', name: 'Land' }, // I18N.TR('Land')
    { id: '#_ctct_name', name: 'Name' }, // I18N.TR('Name')
    { id: '#_ctct_email', name: 'E-Mail' }, // I18N.TR('E-Mail')
    { id: '#_ctct_phone', name: 'Telefon' }, // I18N.TR('Telefon')
];

Consts.Icons = {
    OK: 'fa fa-circle success',
    Error: 'fa fa-circle warning',
    Warning: 'fa fa-circle error',
    Deactivated: 'fa fa-circle deactivated',
    Archived: 'fa fa-circle archived',
};

Consts.DeviceStatus = {
    OK: 0,
    Warning: -1,
    Deactivated: -3,
    Archived: -4,
    Error: null,
};

Consts.DeviceStatusURL = {
    OK: 'ok',
    Warning: 'delayed',
    Deactivated: 'deactivated',
    Error: 'error',
    Archived: 'archived',
};

// Company feature flags
// HINT: add feature flags as need from backend/src/kt/models/company.go
Consts.Features = {
    CommunicationReport: 'communication_report',
    ControllerBackup: 'controller_backup',
    DeviceRanking: 'device_ranking',
    DeviceReporting: 'device_reporting',
    GrantOnsiteAccess: 'grant_onsite_access',
    ManagementInfoReadonly: 'management_info_readonly',
    WeatherData: 'weather_data_access',
    ExtendedValueTransfer: 'extended_value_transfer',
    SmartTemp: 'smart_temp',
};

// Permission constants
// HINT: keep in sync with backend/src/kt/data/consts.go
Consts.Permissions = {
    Info: 1001,
    StateSchema: 1100,
    StateData: 1101,
    EventLog: 1103,
    MeterReadings: 1200,
    Handling: 1300,
    HandlingRemote: 1301,
    HandlingCircuit1: 1302,
    HandlingCircuit2: 1303,
    HandlingCircuit3: 1304,
    HandlingWater: 1305,
    HandlingCircuit11: 1311,
    HandlingCircuit12: 1312,
    HandlingCircuit13: 1313,
    HandlingParameter: 1306,
    Analysis: 1400,
    AdminUser: 1900,
    AdminConfig: 1901,
    AdminDevices: 1902,
};

Consts.RouteToCapability = {
    info: 1001,
    'info-management': 1001,
    'status-schema': 1100,
    'status-data': 1101,
    'status-log': 1103,
    meter: 1200,
    'control-remote': 1301,
    'control-1': 1302,
    'control-2': 1303,
    'control-3': 1304,
    'control-water': 1305,
    'control-11': 1311,
    'control-12': 1312,
    'control-13': 1313,
    'control-parameter': 1306,
    analyze: 1400,
    'admin-user': 1900,
    'admin-configuration': 1901,
    'admin-devices': 1902,
};

Consts.PermissionsCompany = {
    ViewBilling: 8000,
    ManageUsers: 8001,
    EditDesign: 8002,
    AddDevices: 8003,
    RemoveDevices: 8004,
    ViewDevices: 8005,
};

Consts.PermissionsToRoute = {
    1001: 'info',
    1100: 'status-schema',
    1101: 'status-data',
    1103: 'status-log',
    1200: 'meter',
    1300: 'control',
    1301: 'control-remote',
    1302: 'control-1',
    1303: 'control-2',
    1304: 'control-3',
    1305: 'control-water',
    1311: 'control-11',
    1312: 'control-12',
    1313: 'control-13',
    1306: 'control-parameter',
    1400: 'analyze',
    1900: 'admin-user',
    1901: 'admin-configuration',
    1902: 'admin-devices',
};

// configurations for the info-page
Consts.ExternalContent = {};

var minimumInfoConfig = ['name', 'status', 'type', 'alarm', 'tags', 'groups', 'registered', 'events'];

Consts.actuatorTypeString = function (type) {
    return Consts.ActuatorTypes[type] || I18N.TR('Unbekannter Typ');
};

Consts.controllerTypeString = function (type) {
    if (type) {
        return Consts.ControllerTypes[type] || externalTypes(type) || I18N.TR('Unbekannter Typ');
    }
    return I18N.TR('Regler');
};

Consts.gatewayTypeString = function (type) {
    return Consts.GatewayTypes[type] || I18N.TR('Unbekannter Typ');
};

Consts.meterTypeString = function (type) {
    return Consts.MeterTypes[type] || externalTypes(type) || I18N.TR('Unbekannter Typ');
};

Consts.sensorTypeString = function (type) {
    return externalTypes(type) || I18N.TR('Unbekannter Typ');
};

var externalTypes = function (type) {
    // try to match type-string for external devices
    var match = /EXT_([A-Z]+)_([a-z]+)/g.exec(type);
    if (!match || match.length !== 3) {
        return undefined;
    }

    return Consts.ExternalTypes[match[2]];
};

Consts.AggregationByName = {
    NONE: 0,
    SUM: 1,
    AVG: 2,
    MIN: 3,
    MAX: 4,
    MED: 5,
};

Consts.CircuitOffsetsRegister = {
    10: 0, // circuit 1
    11: 0, // circuit 1 constant parametrization
    20: 200, // circuit 2
    21: 200, // circuit 2 constant parametrization
    30: 400, // circuit 3
    31: 400, // circuit 3 constant parametrization
    110: 10100, // circuit 11
    111: 10100, // circuit 11 constant parametrization
    120: 10200, // circuit 12
    121: 10200, // circuit 12 constant parametrization
    130: 10300, // circuit 13
    131: 10300, // circuit 13 constant parametrization
};
Consts.CircuitOffsetsCoils = {
    10: 0, // circuit 1
    11: 0, // circuit 1 constant parametrization
    20: 200, // circuit 2
    21: 200, // circuit 2 constant parametrization
    30: 400, // circuit 3
    31: 400, // circuit 3 constant parametrization
    110: 2076, // circuit 11
    111: 2076, // circuit 11 constant parametrization
    120: 2176, // circuit 12
    121: 2176, // circuit 12 constant parametrization
    130: 2276, // circuit 13
    131: 2276, // circuit 13 constant parametrization
};

Consts.Circuits = {
    1: 10,
    '1Constant': 11,
    2: 20,
    '2Constant': 21,
    3: 30,
    '3Constant': 31,
    WarmWater: 90,
    11: 110,
    '11Constant': 111,
    12: 120,
    '12Constant': 121,
    13: 130,
    '13Constant': 131,
};

Consts.ChartTimeShift = {
    Mode: {
        RELATIVE: { id: 1, name: I18N.TR('Relativ') },
        WITH_DATE: { id: 2, name: I18N.TR('Mit Referenzdatum') },
    },
    Unit: {
        MINUTES: { id: 'minutes', name: I18N.TR('Minuten') },
        HOURS: { id: 'hours', name: I18N.TR('Stunden') },
        DAYS: { id: 'days', name: I18N.TR('Tage') },
        MONTHS: { id: 'months', name: I18N.TR('Monate') },
        YEARS: { id: 'years', name: I18N.TR('Jahre') },
    },
};

Consts.initialize = function () {
    (Consts.DeviceUpdateHint =
        I18N.TR(
            'Aus technischen Gründen lässt es sich nicht ausschließen, dass es im Rahmen des Update-Prozesses zu einer Störung bis hin zu einem Ausfall der Anlage kommt, wodurch die Heizfunktion beeinträchtigt oder unterbrochen werden kann. Sollte so ein Fall auftreten, kann die Wiederherstellung der Funktionsfähigkeit nur vor Ort in der Anlage vorgenommen werden.'
        ) +
        '<br><br>' +
        I18N.TR(
            'Wir empfehlen, den Update-Prozess nur zu beginnen, wenn sichergestellt ist, dass eine Person, die zur Wiederherstellung der Funktionsfähigkeit in der Lage ist, kurzfristig zur Verfügung steht.'
        ) +
        '<br><br>' +
        I18N.TR(
            'Mit einer Verwendung der Schaltfläche „Ausführen“ bestätigen Sie, diese Hinweise zur Kenntnis genommen zu haben und dass eine kurzfristige Wiederherstellung der Funktionsfähigkeit vor Ort sichergestellt ist sowie SAMSON bei einer Störung bzw. einem Ausfall der Anlage keine Verantwortlichkeit trifft. Wir gehen davon aus, dass Sie zur Abgabe der entsprechenden Bestätigungen befugt sind, auch soweit es sich bei Ihnen nicht um den Anlagenbetreiber handelt. Ansonsten ist der Update-Prozess nur durch eine entsprechend befugte Person zu starten.'
        )),
        (Consts.AlarmStatusField = 'STATUS');
    Consts.AlarmStatusFieldText = I18N.TR('Gerätestatus');

    var intervalGroups = [
        {
            name: I18N.TR('Letzte 15 Minuten'),
            settings: { from: -15, till: 0 },
            order: 1,
        },
        {
            name: I18N.TR('Letzte Stunde'),
            settings: { from: -60, till: -15 },
            order: 2,
        },
        {
            name: I18N.TR('Letzte 24 Stunden'),
            settings: { from: -1440, till: -60 },
            order: 3,
        },
        {
            name: I18N.TR('Vor mehr als 24 Stunden'),
            settings: { till: -1440 },
            order: 4,
        },
    ];

    Consts.AlarmGroups = {
        None: { idx: 0, groups: [{}] },
        Name: { idx: 1, keyCol: 'alarm_name' },
        Cond: { idx: 2 },
        Device: { idx: 3, keyCol: 'device_name' },
        Prio: { idx: 4 },
        Interval: { idx: 5, groups: intervalGroups },
    };

    Consts.PermissionPresets = [
        {
            name: 'all',
            text: I18N.TR('Alles'),
            roleName: I18N.TR('Admin'),
        },
        {
            name: 'expert',
            text: I18N.TR('Experte'),
        },
        {
            name: 'standard',
            text: I18N.TR('Standard'),
        },
        {
            name: 'none',
            text: I18N.TR('Keine'),
        },
    ];

    Consts.ErrorMessages = {
        'request failed': I18N.TR('Die Abfrage ist fehlgeschlagen.'),
        access_denied: I18N.TR('Zugriff verweigert.'),
        no_groups: I18N.TR('Es stehen keine Gruppen für die Freigabe zur Verfügung.'),
        already_member: I18N.TR('Dieser Nutzer ist in den ausgewählten Gruppen bereits Mitglied.'),
        general_error: I18N.TR('Der Vorgang ist fehlgeschlagen.'),
    };

    Consts.Events = {
        AlarmTriggered: { name: I18N.TR('Alarm ausgelöst'), value: 'alarm_trigger', icon: 'fa fa-bell error' },
        AlarmAcknowledged: { name: I18N.TR('Alarm quittiert'), value: 'alarm_ack', icon: 'fa fa-check success' },

        DeviceOK: { name: I18N.TR('Gerätestatus OK'), value: 'device_ok', icon: 'fa fa-check success' },
        DeviceRegistered: { name: I18N.TR('Geräteregistrierung'), value: 'device_reg', icon: 'fa fa-info-circle' },
        DeviceSeen: { name: I18N.TR('Zuletzt gemeldet'), value: 'device_seen', icon: 'fa fa-info-circle' },
        DeviceStatus: {
            name: I18N.TR('Gerätestatus'),
            value: 'device_status',
            icon: 'fa fa-exclamation-triangle warning',
        },
        DeviceReplacement: { name: I18N.TR('Gerätetausch'), value: 'device_replacement', icon: 'fa fa-exchange' },
        DeviceOnsiteAccessGranted: {
            name: I18N.TR('Freigabe für vor-Ort-Konfiguration'),
            value: 'device_grant_onsite_access',
            icon: 'fa fa-key',
        },
        DeviceTimeSync: { name: I18N.TR('Zeitsynchronisation'), value: 'meter_time_sync', icon: 'fa fa-clock-o' },
        DeviceTimeAnomaly: {
            name: I18N.TR('Zeitabweichung zu groß'),
            value: 'meter_time_anomaly',
            icon: 'fa fa-exclamation-triangle error',
        },
        DeviceBackup: { name: I18N.TR('Backup'), value: 'create_backup', icon: 'fa fa-download' },
    };

    Consts.buildInfoConfig();

    Consts.AggregationIdx = {
        1: 'SUM',
        2: 'AVG',
        3: 'MIN',
        4: 'MAX',
        5: 'MED',
    };

    Consts.Aggregation = [
        { id: 'SUM', name: I18N.TR('Summe') },
        { id: 'AVG', name: I18N.TR('Durchschnitt') },
        { id: 'MIN', name: I18N.TR('Minimum') },
        { id: 'MAX', name: I18N.TR('Maximum') },
        { id: 'MED', name: I18N.TR('Median') },
    ];

    Consts.AggregationDeviceReport = [
        { id: 'MEAN', name: I18N.TR('Durchschnitt') },
        { id: 'MIN', name: I18N.TR('Minimum') },
        { id: 'MAX', name: I18N.TR('Maximum') },
        { id: 'MEDIAN', name: I18N.TR('Median') },
        { id: 'LAST', name: I18N.TR('Letzter Wert') },
        { id: 'DIFF', name: I18N.TR('Differenz MAX-MIN') },
    ];

    Consts.DeviceReportModes = [
        { id: 0, name: I18N.TR('Tabelle'), icon: 'fa fa-table' },
        { id: 6, name: I18N.TR('Tabelle mit Zeitverlauf'), icon: 'fa fa-table' },
        { id: 1, name: I18N.TR('Histogram - Balkendiagramm'), icon: 'fa fa-bar-chart' },
        { id: 2, name: I18N.TR('Histogram - Tortendiagramm'), icon: 'fa fa-pie-chart' },
        { id: 3, name: I18N.TR('Histogram - Tabelle'), icon: 'fa fa-table' },
        { id: 4, name: I18N.TR('Zeitverlauf'), icon: 'fa fa-line-chart' },
        { id: 5, name: I18N.TR('Zeitverlauf - Balken'), icon: 'fa fa-bar-chart' },
    ];

    Consts.DeviceReportModeProp = {
        0: { isTable: true, isGlobal: true },
        3: { isTable: true },
        6: { isTable: true, isGlobal: true },
    };

    Consts.DeviceTypeText = {};
    Consts.DeviceCategory = {};

    Consts.DeviceStatusText = {
        OK: I18N.TR('funktioniert'),
        Warning: I18N.TR('nicht gemeldet'),
        Error: I18N.TR('fehlerhaft'),
        Deactivated: I18N.TR('inaktiv'),
        Archived: I18N.TR('archiviert'),
    };

    Consts.PermissionsLabel = {
        1001: I18N.TR('Info'),
        1100: I18N.TR('Anlagenschema'),
        1101: I18N.TR('Daten'),
        1103: I18N.TR('Ereignisse'),
        1200: I18N.TR('Zählerstand'),
        1300: I18N.TR('Bedienung'),
        1301: I18N.TR('Fernbedienung'),
        1302: I18N.TR('Heizkreis 1'),
        1303: I18N.TR('Heizkreis 2'),
        1304: I18N.TR('Heizkreis 3'),
        1305: I18N.TR('Trinkwasser'),
        1311: I18N.TR('Heizkreis 11'),
        1312: I18N.TR('Heizkreis 12'),
        1313: I18N.TR('Heizkreis 13'),
        1306: I18N.TR('Parametrierung'),
        1400: I18N.TR('Analyse'),
        1900: I18N.TR('Nutzer'),
        1901: I18N.TR('Konfiguration'),
        1902: I18N.TR('Geräte'),
    };

    Consts.ActuatorTypes = {
        3374: I18N.TR('Typ 3374'),
        3375: I18N.TR('Typ 3375'),
        5724: I18N.TR('TROVIS 5724-8'),
        5725: I18N.TR('TROVIS 5725-8'),
    };

    // HINT: synchronize with backend/src/kt/web/devices.go -- DeviceTypeRules
    Consts.ControllerTypes = {
        5476: I18N.TR('TROVIS 5476'),
        5573: I18N.TR('TROVIS 5573'),
        '5573_1': I18N.TR('TROVIS 5573'),
        '5573_3': I18N.TR('TROVIS 5578'),
        EQJW126: I18N.TR('EQJW126'),
        EQJW146: I18N.TR('EQJW146'),
        PCR06: I18N.TR('PEWO PCR06'),
        5575: I18N.TR('TROVIS 5575'),
        5576: I18N.TR('TROVIS 5576'),
        5578: I18N.TR('TROVIS 5578'),
        EQJW246: I18N.TR('EQJW246'),
        5579: I18N.TR('TROVIS 5579'),
    };

    Consts.GatewayTypes = {
        5014: I18N.TR('SAM MOBILE Gateway'),
        5015: I18N.TR('SAM HOME Gateway'),
        5016: I18N.TR('SAM LAN Gateway (Aggregationsknoten)'),
        '5016_pn': I18N.TR('SAM LAN Gateway (Reglerknoten)'),
        5018: I18N.TR('TROVIS 5578-E'),
        5019: I18N.TR('SAM VM Gateway'),
        5020: I18N.TR('Media7 DFÜ Modul'),
        5021: I18N.TR('SAM HOME GRID'),
        5022: I18N.TR('SAM METER Gateway'),
        5024: I18N.TR('SAM MOBILE+ Gateway'),
        5578: I18N.TR('TROVIS 5578-E'),
    };

    Consts.MeterTypes = {
        wmz: I18N.TR('Wärmemengenzähler'),
        wmz_solvimus: I18N.TR('Wärmemengenzähler'),
        ez: I18N.TR('Elektrozähler'),
        kwz: I18N.TR('Kaltwasserzähler'),
    };

    Consts.ExternalTypes = {
        ez: I18N.TR('Elektrozähler'),
        gz: I18N.TR('Gaszähler'),
        wmz: I18N.TR('Wärmemengenzähler'),
        wz: I18N.TR('Wasserzähler'),
        s: I18N.TR('Sensor'),
        r: I18N.TR('Regler'),
        ats: I18N.TR('Außentemperatursensor'),
        hkv: I18N.TR('Heizkostenverteiler'),
        xxx: I18N.TR('Unbekannt'),
    };

    Consts.DayNames = [
        I18N.TR('Montag'),
        I18N.TR('Dienstag'),
        I18N.TR('Mittwoch'),
        I18N.TR('Donnerstag'),
        I18N.TR('Freitag'),
        I18N.TR('Samstag'),
        I18N.TR('Sonntag'),
    ];

    Consts.MonthNames = [
        I18N.TR('Januar'),
        I18N.TR('Februar'),
        I18N.TR('März'),
        I18N.TR('April'),
        I18N.TR('Mai'),
        I18N.TR('Juni'),
        I18N.TR('Juli'),
        I18N.TR('August'),
        I18N.TR('September'),
        I18N.TR('Oktober'),
        I18N.TR('November'),
        I18N.TR('Dezember'),
    ];

    Consts.MonthNamesShort = [
        I18N.TR('Jan'),
        I18N.TR('Feb'),
        I18N.TR('Mär'),
        I18N.TR('Apr'),
        I18N.TR('Mai'),
        I18N.TR('Jun'),
        I18N.TR('Jul'),
        I18N.TR('Aug'),
        I18N.TR('Sep'),
        I18N.TR('Okt'),
        I18N.TR('Nov'),
        I18N.TR('Dez'),
    ];

    Consts.DaysOfWeek = [
        I18N.TR('So'),
        I18N.TR('Mo'),
        I18N.TR('Di'),
        I18N.TR('Mi'),
        I18N.TR('Do'),
        I18N.TR('Fr'),
        I18N.TR('Sa'),
    ];

    Consts.ReportPeriods = [
        // {value: 1, text: I18N.TR('stündlich')},
        { value: 2, text: I18N.TR('täglich') },
        { value: 3, text: I18N.TR('wöchentlich') },
        { value: 4, text: I18N.TR('monatlich') },
        { value: 5, text: I18N.TR('jährlich') },
    ];

    Consts.ReportFormats = [
        { value: 1, icon: 'fa fa-file-excel-o m-r-5', text: I18N.TR('CSV') },
        { value: 2, icon: 'fa fa-file-pdf-o m-r-5', text: I18N.TR('PDF') },
    ];

    Consts.ChartTimeWindows = function () {
        return [
            { id: 1, mins: 15, name: '15 ' + I18N.TR('Minuten') },
            { id: 2, mins: 60, name: '1 ' + I18N.TR('Stunde'), weatherData: true },
            { id: 3, mins: 240, name: '4 ' + I18N.TR('Stunden') },
            { id: 4, mins: 1440, name: '1 ' + I18N.TR('Tag') },
            { id: 5, mins: 10080, name: '1 ' + I18N.TR('Woche') },
            { id: 6, mins: 1440, name: '1 ' + I18N.TR('Monat'), actual: 'month' },
        ];
    };

    Consts.FilterComparison = ['=', '<', '<=', '>', '>=', '<>'];

    Consts.Priorities = function () {
        var data = [
            { prio: 1, name: I18N.TR('Niedrig') },
            { prio: 2, name: I18N.TR('Mittel') },
            { prio: 3, name: I18N.TR('Hoch') },
        ];
        return data;
    };

    Consts.RemoteControlCmd = {
        ModeSelector: 1,
        ProgDown: 2,
        ProgUp: 3,
        KnobDown: 4,
        KnobUp: 5,
        KnobSet: 6,

        ScreenStart: 256,
        ScreenStop: 257,
        ScreenPause: 258,
    };

    Consts.DefaultCircuitNames = {
        'control-1': I18N.TR('Heizkreis 1'),
        'control-2': I18N.TR('Heizkreis 2'),
        'control-3': I18N.TR('Heizkreis 3'),
        'control-water': I18N.TR('Trinkwasser'),
        'control-11': I18N.TR('Heizkreis 11'),
        'control-12': I18N.TR('Heizkreis 12'),
        'control-13': I18N.TR('Heizkreis 13'),
        external: I18N.TR('externe Bedarfsanforderung'),
    };

    Consts.QuickMenuRoutes = [
        { permission: 1001, icon: 'fa fa-info-circle', url: 'info', name: I18N.TR('Info') },
        { permission: 1100, icon: 'fa fa-adjust', url: 'status-schema', name: I18N.TR('Anlagenschema') },
        {
            permission: 1101,
            icon: 'fa fa-adjust',
            url: 'overview',
            name: I18N.TR('Gesamtübersicht'),
            categories: ['Gateway', 'Gateway-RF'],
        },
        { permission: 1101, icon: 'fa fa-adjust', url: 'status-data', name: I18N.TR('Daten') },
        { permission: 1200, icon: 'fa fa-tachometer', url: 'meter', name: I18N.TR('Zählerstand') },
        { permission: 1400, icon: 'fa fa-bar-chart', url: 'analyze', name: I18N.TR('Analyse') },
    ];

    Consts.SmartTempData = [
        {
            type: 'DEVICE',
            category: 'Meter',
            adminOnly: true,
            activeOnly: false,
            hc: null,
            field: 'DEVICE_3',
            name: I18N.TR('Lastprognose'),
            format: 'f0',
            unit: 'W',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: true,
            activeOnly: false,
            hc: 'HC1',
            field: 'DEVICE_4',
            name: I18N.TR('Interner Zustand HK1'),
            format: '/100f2',
            unit: '',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: false,
            hc: 'HC1',
            field: 'DEVICE_5',
            name: I18N.TR('Optimierter Sollwert HK1'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: true,
            hc: 'HC1',
            field: 'DEVICE_6',
            name: I18N.TR('Konfigurierter Sollwert HK1'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: true,
            activeOnly: false,
            hc: 'HC2',
            field: 'DEVICE_7',
            name: I18N.TR('Interner Zustand HK2'),
            format: '/100f2',
            unit: '',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: false,
            hc: 'HC2',
            field: 'DEVICE_8',
            name: I18N.TR('Optimierter Sollwert HK2'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: true,
            hc: 'HC2',
            field: 'DEVICE_9',
            name: I18N.TR('Konfigurierter Sollwert HK2'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: true,
            activeOnly: false,
            hc: 'HC3',
            field: 'DEVICE_10',
            name: I18N.TR('Interner Zustand HK3'),
            format: '/100f2',
            unit: '',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: false,
            hc: 'HC3',
            field: 'DEVICE_11',
            name: I18N.TR('Optimierter Sollwert HK3'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: true,
            hc: 'HC3',
            field: 'DEVICE_12',
            name: I18N.TR('Konfigurierter Sollwert HK3'),
            format: '/10f1',
            unit: '°C',
        },
        {
            type: 'DEVICE',
            category: '55xx56xx',
            adminOnly: false,
            activeOnly: false,
            hc: 'AF',
            field: 'DEVICE_13',
            name: I18N.TR('Optimierter Außenfühlerwert'),
            format: '/10f1',
            unit: '°C',
        },
    ];

    Consts.WeatherData = [
        { type: 'WD', field: 'WD_temperature', name: I18N.TR('Temperatur'), format: '/10f1', unit: '°C' },
        {
            type: 'WD',
            field: 'WD_precipProbability',
            name: I18N.TR('Niederschlagswahrscheinlichkeit'),
            format: '/0.01f0',
            unit: '%',
            min: 0,
            max: 1,
        },
        {
            type: 'WD',
            field: 'WD_precipIntensity',
            name: I18N.TR('Niederschlagsintensität'),
            format: 'f2',
            unit: 'mm/h',
        },
        {
            type: 'WD',
            field: 'WD_cloudCover',
            name: I18N.TR('Bewölkung'),
            format: '/0.01f0',
            unit: '%',
            min: 0,
            max: 1,
        },
        {
            type: 'WD',
            field: 'WD_humidity',
            name: I18N.TR('Luftfeuchtigkeit'),
            format: '/0.01f0',
            unit: '%',
            min: 0,
            max: 1,
        },
        {
            type: 'WD',
            field: 'WD_apparentTemperature',
            name: I18N.TR('Gefühlte Temperatur'),
            format: '/10f1',
            unit: '°C',
        },
        { type: 'WD', field: 'WD_windSpeed', name: I18N.TR('Windgeschwindigkeit'), format: 'f0', unit: 'km/h' },
        { type: 'WD', field: 'WD_solarRadiation', name: I18N.TR('Sonneneinstrahlung'), format: 'f0', unit: 'W/m²' },
    ];

    // "register" standard smart detection rule names for translation

    // I18N.TR('Gerät für langen Zeitraum nicht erreichbar')
    // I18N.TR('Kommunikationsfehler (RS232/RS485/MBus)')
    // I18N.TR('Häufig Regelabweichungen HK1')
    // I18N.TR('Häufig Regelabweichungen HK2')
    // I18N.TR('Häufig Regelabweichungen HK3')
    // I18N.TR('Häufig zu hohe Rücklauftemperatur HK1')
    // I18N.TR('Häufig zu hohe Rücklauftemperatur HK2')
    // I18N.TR('Häufig zu hohe Rücklauftemperatur HK3')
    // I18N.TR('Zu niedrige Speichertemperatur (Legionellen-Gefahr)')
    // I18N.TR('Häufig Sensorausfall')
    // I18N.TR('Regelung schwingt HK1')
    // I18N.TR('Regelung schwingt HK2')
    // I18N.TR('Regelung schwingt HK3')
    // I18N.TR('Frei konfigurierbare Fehlermeldungen (Error 8) ausgelöst')
    // I18N.TR('Wärmetauscher verschmutzt oder verkalkt')
    // I18N.TR('Energiereserve niedrig')
    // I18N.TR('Geringe Spreizung')
    // I18N.TR('Primär-Vorlauftemperatur zu niedrig')
    // I18N.TR('Primär Rücklauf heißer als Vorlauf')
    // I18N.TR('Frostgefahr')
    // I18N.TR('Zu hohe Umgebungstemperatur')
    // I18N.TR('Häufiges Laden von Trinkwarmwasser')
    // I18N.TR('Negativer Durchfluss')

    Consts.RankingRuleInfos = {
        // Gerät für langen Zeitraum nicht erreichbar
        20: I18N.TR(
            'Das Gerät war oder ist für einen langen Zeitraum nicht erreichbar. In diesem Zeitraum können auch keine Daten empfangen oder verarbeitet werden. Gründe könnten z. B. sein:<ul><li>Keine Spannungsversorgung</li><li>Schlechter oder unzureichender Empfang. Meist hilft hier eine andere Position der Antenne (z. B. in Fensternähe).</li></ul>'
        ),
        // Kommunikationsfehler (RS232/RS485/MBus)
        30: I18N.TR(
            'Das Gerät meldet häufig Kommunikationsprobleme. Gründe könnten z. B. sein: <ul><li>Fehlerhafter Anschluss von Geräten an das Gateway</li><li>Fehlerhafte Konfiguration (MBus-Adressen, Stationsadressen, Baudrate)</li><li>Geräte aktuell nicht erreichbar (ausgeschaltet)</li></ul>'
        ),
        // Häufig Regelabweichungen HK1
        40: I18N.TR(
            'Die Regelung weist häufig Regelabweichungen auf. Gründe könnten z. B. sein:<ul><li>Unpassende Regelparameter</li><li>Einschwingen beim Aktivieren (Dies kann durchaus gewünscht sein, um schneller die Zieltemperatur zu erreichen)</li><li>Hydraulische Problem (z. B. zu große Regelarmaturen ausgelegt, nachträgliche Veränderung der Hydraulik)</li></ul>'
        ),
        // Häufig Regelabweichungen HK2
        41: I18N.TR(
            'Die Regelung weist häufig Regelabweichungen auf. Gründe könnten z. B. sein:<ul><li>Unpassende Regelparameter</li><li>Einschwingen beim Aktivieren (Dies kann durchaus gewünscht sein, um schneller die Zieltemperatur zu erreichen)</li><li>Hydraulische Problem (z. B. zu große Regelarmaturen ausgelegt, nachträgliche Veränderung der Hydraulik)</li></ul>'
        ),
        // Häufig Regelabweichungen HK3
        42: I18N.TR(
            'Die Regelung weist häufig Regelabweichungen auf. Gründe könnten z. B. sein:<ul><li>Unpassende Regelparameter</li><li>Einschwingen beim Aktivieren (Dies kann durchaus gewünscht sein, um schneller die Zieltemperatur zu erreichen)</li><li>Hydraulische Problem (z. B. zu große Regelarmaturen ausgelegt, nachträgliche Veränderung der Hydraulik)</li></ul>'
        ),
        // Häufig zu hohe Rücklauftemperatur HK1
        50: I18N.TR(
            'Die primär Rücklauftemperatur im Fernwärmenetz ist häufig höher als die eingestellten Grenzen. Gründe könnten z. B. sein:<ul><li>Warmwasserbereitung</li><li>Keine Abnahme</li><li>Hydraulische Problem</li><li>Defekter Wärmetauscher</li><li>Grenzwert zu niedrig eingestellt, örtliche TAB prüfen</li></ul>'
        ),
        // Häufig zu hohe Rücklauftemperatur HK2
        51: I18N.TR(
            'Die primär Rücklauftemperatur im Fernwärmenetz ist häufig höher als die eingestellten Grenzen. Gründe könnten z. B. sein:<ul><li>Warmwasserbereitung</li><li>Keine Abnahme</li><li>Hydraulische Problem</li><li>Defekter Wärmetauscher</li><li>Grenzwert zu niedrig eingestellt, örtliche TAB prüfen</li></ul>'
        ),
        // Häufig zu hohe Rücklauftemperatur HK3
        52: I18N.TR(
            'Die primär Rücklauftemperatur im Fernwärmenetz ist häufig höher als die eingestellten Grenzen. Gründe könnten z. B. sein:<ul><li>Warmwasserbereitung</li><li>Keine Abnahme</li><li>Hydraulische Problem</li><li>Defekter Wärmetauscher</li><li>Grenzwert zu niedrig eingestellt, örtliche TAB prüfen</li></ul>'
        ),
        // Zu niedrige Speichertemperatur (Legionellen-Gefahr)
        60: I18N.TR(
            'Der Sollwert der Warmwasserbereitung wurde nicht erreicht. Dies birgt das Risiko einer hohen Keimbelastung (z. B. Legionellen). Gründe können z. B. sein:<ul><li>Zu geringe Überhöhung im Regler parametriert</li><li>Verkalkung oder Verschmutzung des Wärmetauschers</li><li>Keine ausreichende Versorgungstemperatur</li><li>Falsche Position des Temperaturfühleres</li></ul>'
        ),
        // Häufig Sensorausfall
        70: I18N.TR(
            'Es wurde in der Anlage häufig ein Sensorausfall festgestellt. Gründe könnten z. B. sein:<ul><li>Wackelkontakt (Anschlussklemmen nachziehen)</li><li>Installations- oder Servicearbeiten an der Station</li></ul>'
        ),
        // Regelung schwingt HK1
        80: I18N.TR(
            'Wird nach einiger Zeit bei der Regelung nicht der eingestellte Sollwert erreicht und ausgeregelt, sondern weist starke Abweichung im Wechsel auf (Wellenförmig um Sollwert herum), spricht man vom Dauerschwingen. Dies hat häufig negative Auswirkungen auf den Verschleiß, die Regelgüte und die Energiebilanz. Gründe könnten z. B. sein: <ul><li>Unpassende Regelparameter</li><li>Zu groß ausgelegte Regelarmaturen</li><li>Störgrößen</li><li>Falsche Position des Temperaturfühlers</li></ul>'
        ),
        // Regelung schwingt HK2
        81: I18N.TR(
            'Wird nach einiger Zeit bei der Regelung nicht der eingestellte Sollwert erreicht und ausgeregelt, sondern weist starke Abweichung im Wechsel auf (Wellenförmig um Sollwert herum), spricht man vom Dauerschwingen. Dies hat häufig negative Auswirkungen auf den Verschleiß, die Regelgüte und die Energiebilanz. Gründe könnten z. B. sein: <ul><li>Unpassende Regelparameter</li><li>Zu groß ausgelegte Regelarmaturen</li><li>Störgrößen</li><li>Falsche Position des Temperaturfühlers</li></ul>'
        ),
        // Regelung schwingt HK3
        82: I18N.TR(
            'Wird nach einiger Zeit bei der Regelung nicht der eingestellte Sollwert erreicht und ausgeregelt, sondern weist starke Abweichung im Wechsel auf (Wellenförmig um Sollwert herum), spricht man vom Dauerschwingen. Dies hat häufig negative Auswirkungen auf den Verschleiß, die Regelgüte und die Energiebilanz. Gründe könnten z. B. sein: <ul><li>Unpassende Regelparameter</li><li>Zu groß ausgelegte Regelarmaturen</li><li>Störgrößen</li><li>Falsche Position des Temperaturfühlers</li></ul>'
        ),
        // Frei konfigurierbare Fehlermeldungen (Error 8) ausgelöst
        90: I18N.TR(
            'Die TROVIS Regler bieten die Möglichkeit freie Binäreingänge als Störeingänge zu konfigurieren. Grund ist der jeweils verwendete Einsatzzwecke des Betreibers.<ul><li>Diese haben ausgelöst.</li><li>Oder Wirkrichtung CO8 prüfen.</li></ul>'
        ),
        // Wärmetauscher verschmutzt oder verkalkt
        100: I18N.TR(
            'Die Temperatur an VF4 wird nicht erreicht. <br/>Gründe könnten z. B. sein:<ul><li>Wärmetauscher verschmutzt</li><li>Wärmetauscher verkalkt</li><li>Wärmetauscher defekt</li></ul>'
        ),
        // Energiereserve niedrig
        110: I18N.TR(
            'Der Zähler meldet Probleme mit der Energieversorgung. Eventuell ist ein Batteriewechsel erforderlich.'
        ),
        // Zählerfehler für langen Zeitraum
        120: I18N.TR(
            'Es sind langandauernde Zählerfehler aufgetreten. Dies kann unterschiedliche Gründe haben, mehr Infos sehen Sie im Ereignisprotokoll oder am Zähler.'
        ),
        // Geringe Spreizung
        130: I18N.TR(
            'Die Temperaturdifferenz zwischen primär Vorlauf und primär Rücklauf ist sehr gering oder negativ. Gründe könnten z. B. sein:<ul><li>Keine Abnahme</li><li>Anlage abgeschiebert</li><li>Wärmetauscher defekt</li></ul>'
        ),
        // Primär-Vorlauftemperatur zu niedrig
        140: I18N.TR(
            'Die primärseitige Vorlauftemperatur ist oder war sehr gering. Dies lässt eine Unterversorgung vermuten. Gründe könnten z. B. sein:<ul><li>Station ist deaktiviert und abgeschiebert</li><li>Wartungsarbeiten</li><li>Sensoren nicht oder nicht richtig mit dem Medium verbunden</li></ul>'
        ),
        // Primär Rücklauf heißer als Vorlauf
        150: I18N.TR(
            'Die primäre Rücklauftemperatur war oder ist höher als die primäre Vorlauftemperatur. Gründe könnten z. B. sein:<ul><li>Station ist deaktiviert und abgeschiebert</li><li>Wartungsarbeiten</li><li>Sensoren vertauscht</li><li>Sensoren nicht oder nicht richtig mit dem Medium verbunden</li></ul>'
        ),
        // Frostgefahr
        160: I18N.TR(
            'Es waren oder sind Wassertemperaturn unter 10° gemessen worden. Hierbei herrscht Frostgefahr. Dies kann zu erheblichen Schäden an der Station führen.'
        ),
        // Zu hohe Umgebungstemperatur
        170: I18N.TR(
            'Die durchschnittliche Umgebungstemperatur des Reglers ist deutlich höher als die zulässige Betriebstemperatur. Dies kann die erwartete Lebensdauer des Gerätes deutlich verringern. Prüfen Sie Leitungsdämmungen oder Lüfter im Schaltschrank.'
        ),
        // Häufiges Laden von Trinkwarmwasser
        //		180: I18N.TR(''),
        // Negativer Durchfluss
        1010001: I18N.TR(
            'Es wurde oder wird negativer Durchfluss an der Anlage gemessen. Gründe könnten z. B. sein:<ul><li>Station ist deaktiviert</li><li>Wartungsarbeiten</li><li>Sensoren falsch montiert</li><li>Sonderanlage (Konsument und Produzent)</li></ul>'
        ),
    };

    Consts.RankingRuleQuickAnalysisInfo = {
        // Gerät für langen Zeitraum nicht erreichbar
        20: {
            showEvents: true,
            dataList: ['MBR_137'],
            deltaStart: 7920 * 60 * 1000,
        },
        // Häufig Regelabweichungen HK1
        40: {
            showEvents: false,
            dataList: ['MBR_13', 'MBR_1000', 'MBR_107'],
            deltaStart: 50 * 60 * 1000,
        },
        // Häufig Regelabweichungen HK2
        41: {
            showEvents: false,
            dataList: ['MBR_14', 'MBR_1200', 'MBR_109'],
            deltaStart: 50 * 60 * 1000,
        },
        // Häufig Regelabweichungen HK3
        42: {
            showEvents: false,
            dataList: ['MBR_15', 'MBR_1400', 'MBR_111'],
            deltaStart: 50 * 60 * 1000,
        },
        // Häufig zu hohe Rücklauftemperatur HK1
        50: {
            showEvents: false,
            dataList: ['MBR_17', 'MBR_1033'],
            deltaStart: 30 * 60 * 1000,
        },
        // Häufig zu hohe Rücklauftemperatur HK2
        51: {
            showEvents: false,
            dataList: ['MBR_18', 'MBR_1233'],
            deltaStart: 30 * 60 * 1000,
        },
        // Häufig zu hohe Rücklauftemperatur HK3
        52: {
            showEvents: false,
            dataList: ['MBR_19', 'MBR_1433'],
            deltaStart: 30 * 60 * 1000,
        },
        // Zu niedrige Speichertemperatur (Legionellen-Gefahr)
        60: {
            showEvents: false,
            dataList: ['MBR_23', 'MBR_24'],
            deltaStart: 80 * 60 * 1000,
        },
        // Häufig Sensorausfall
        70: {
            showEvents: true,
            dataList: ['MBR_10', 'MBR_11', 'MBR_13', 'MBR_14', 'MBR_17', 'MBR_18', 'MBR_23', 'MBR_24'],
            deltaStart: 20 * 60 * 1000,
        },
        // Regelung schwingt HK1
        80: {
            showEvents: false,
            dataList: ['MBR_13', 'MBR_1000', 'MBR_107'],
            deltaStart: 35 * 60 * 1000,
        },
        // Regelung schwingt HK2
        81: {
            showEvents: false,
            dataList: ['MBR_14', 'MBR_1200', 'MBR_109'],
            deltaStart: 35 * 60 * 1000,
        },
        // Regelung schwingt HK3
        82: {
            showEvents: false,
            dataList: ['MBR_15', 'MBR_1400', 'MBR_111'],
            deltaStart: 35 * 60 * 1000,
        },
        // Wärmetauscher verschmutzt oder verkalkt
        100: {
            showEvents: false,
            dataList: ['MBR_6527', 'MBR_13'],
            deltaStart: 11520 * 60 * 1000,
        },
        // Energiereserve niedrig
        110: {
            showEvents: true,
            dataList: ['MBR_6523', 'MBR_6527', 'MBR_6518'],
            deltaStart: 50 * 60 * 100,
        },
        // Geringe Spreizung
        130: {
            showEvents: false,
            dataList: ['MBR_10', 'MBR_6523', 'MBR_6527'],
            deltaStart: 65 * 60 * 1000,
        },
        // Primär-Vorlauftemperatur zu niedrig
        140: {
            showEvents: false,
            dataList: ['MBR_6523', 'MBR_6527', 'MBR_6506'],
            deltaStart: 65 * 60 * 1000,
        },
        // Primär Rücklauf heißer als Vorlauf
        150: {
            showEvents: false,
            dataList: ['MBR_6523', 'MBR_6527', 'MBR_6506'],
            deltaStart: 65 * 60 * 1000,
        },
        // Frostgefahr
        160: {
            showEvents: true,
            dataList: ['MBR_6523', 'MBR_6527', 'MBR_6506'],
            deltaStart: 50 * 60 * 1000,
        },
        // Vertragswert nicht erreicht
        1020001: {
            showEvents: false,
            dataList: ['MBR_6506', 'SCR_1', 'SCR_10'],
            deltaStart: 85 * 60 * 1000,
        },
        // Vertragswert überschritten
        1020002: {
            showEvents: false,
            dataList: ['MBR_6506', 'SCR_1'],
            deltaStart: 85 * 60 * 1000,
        },
        // Defekte Trinkwarmwassererzeugung
        1020003: {
            showEvents: false,
            dataList: ['MBR_6506', 'SCR_1'],
            deltaStart: 85 * 60 * 1000,
        },
    };
};

Consts.buildInfoConfig = function () {
    Consts.InfoConfig = {
        Default: {
            last_seen: I18N.TR('Letzter Kontakt'),
            registered: I18N.TR('Angemeldet seit'),
        },
    };
    _.each(Consts.CategoryData, function (data, category) {
        data.columns = _.sortBy(data.columns, 'name');
        var infoObj = {};
        _.each(data.info, function (fields, key) {
            infoObj[key] = {};
            _.each(fields, function (field) {
                var name = _.map(
                    _.filter(data.columns, function (x) {
                        return x.id == '#_' + field;
                    }),
                    function (x) {
                        return I18N.TR(x.name);
                    }
                );
                if (name.length) {
                    infoObj[key][field] = name[0];
                }
            });
        });
        Consts.InfoConfig[category] = infoObj;
    });
};

Consts.initializeCategories = function (categories) {
    var generalStatusErrors = {
        codes: {
            DeviceStatusDeactivated: -3,
            DeviceStatusUnknown: -2,
            DeviceStatusDelayed: -1,
            DeviceStatusOK: 0,
        },
        messages: {
            DeviceStatusUnknown: I18N.TR('Grätestatus unbekannt'),
            DeviceStatusDeactivated: I18N.TR('Gerät inaktiv'),
            DeviceStatusDelayed: I18N.TR('Gerät nicht erreichbar'),
            DeviceStatusOK: I18N.TR('Gerät betriebsbereit'),
        },
    };

    // save icons, names, ...
    SharedData.InitRequired();
    var CategoryData = {};
    var AllCategoryData = {};

    _.each(SharedData.GetCategories(), function (value, key) {
        if (categories[value.category]) {
            CategoryData[key] = value;
        }
        AllCategoryData[key] = value;
    });
    Consts.CategoryData = CategoryData;
    Consts.AllCategoryData = AllCategoryData;

    _.each(Consts.CategoryData, function (data, category) {
        data.categoryKey = category;
        // TODO: remove this HACK
        Consts.Category[category] = data.category;
        Consts.Icons[category] = data.icon;
        Consts.DeviceTypeText[category] = data.name;
        Consts.ExternalContent[category] = {};
        Consts.DeviceCategory[data.category] = data;
        data.columns = _.sortBy(data.columns, 'name');
        data.statusErrors = data.statusErrors || generalStatusErrors;
    });

    Consts.Backend = SharedData.InitConsts();

    Consts.buildInfoConfig();

    Consts.ExternalContent['55xx56xx'] = {
        e: I18N.TR('Bedienungsanleitung'),
        t: I18N.TR('Typenblatt'),
        w: I18N.TR('Webseite des Herstellers'),
    };
    Consts.ExternalContent['Gateway'] = {
        e: I18N.TR('Bedienungsanleitung'),
        f: I18N.TR('Firmware'),
    };
    Consts.ExternalContent['Gateway-RF'] = Consts.ExternalContent['Gateway'];
};

Consts.HeaderKeys = {
    xDevLocked: 'X-Lock-State-Device',
    xTrovisToken: 'X-Trovis-Token',
};

Consts.HeatCharacteristicTypes = {
    ConstantValue: 0,
    FourPoint: 1,
    Gradient: 2,
};

// Contains all coils that only occure in an additional Trovis I/O Circuit
Consts.TrovisIOCoils = {
    UP11: 'UP1',
    UP12: 'UP1',
    UP13: 'UP1',
    RK11_e: 'RK1_e',
    RK12_e: 'RK1_e',
    RK13_e: 'RK1_e',
    UP11_e: 'UP1_e',
    UP12_e: 'UP1_e',
    UP13_e: 'UP1_e',
};

// Contains all register that only occure in an additional Trovis I/O Circuit
Consts.TrovisIORegister = {
    RK11: 'RK1',
    RK12: 'RK1',
    RK13: 'RK1',
    RüF11_s: 'RüF1_s',
    RüF12_s: 'RüF1_s',
    RüF13_s: 'RüF1_s',
    RüF11: 'RüF1',
    RüF12: 'RüF1',
    RüF13: 'RüF1',
    VF11: 'VF1',
    VF12: 'VF1',
    VF13: 'VF1',
    VF11_s: 'VF1_s',
    VF12_s: 'VF1_s',
    VF13_s: 'VF1_s',
    TagsollwertHK11: 'TagsollwertHK1',
    TagsollwertHK12: 'TagsollwertHK1',
    TagsollwertHK13: 'TagsollwertHK1',
    NachtsollwertHK11: 'NachtsollwertHK1',
    NachtsollwertHK12: 'NachtsollwertHK1',
    NachtsollwertHK13: 'NachtsollwertHK1',
    FestwertTagHK11: 'FestwertTagHK1',
    FestwertTagHK12: 'FestwertTagHK1',
    FestwertTagHK13: 'FestwertTagHK1',
};

Consts.GatewayTypeIDs = {
    SAMMobile: '5014',
    SAMHome: '5015',
    RF: '5016',
    TrovisIO: '5017',
    RegComTCP: '5018',
    SAMVM: '5019',
    Media7: '5020',
    SAMHG: '5021',
    SAMMobilePlus: '5024',
};

Consts.GatewayWithMBus = ['5014', '5015', '5016', '5022', '5024', '5578'];

Consts.ValueTypeClass = {
    MBI: 'MBR',
    MBD: 'MBC',
    SCR: 'MBR',
    VDR: 'MBR',
    VDC: 'MBC',
    VDS: 'MBR',
    VDI: 'MBR',
    VDT: 'MBC',
};

Consts.ValueTypesVisible = {
    MBC: true,
    MBR: true,
    MBD: true,
    MBI: true,
};

Consts.ValueTypesVirtual = {
    VDR: true,
    VDC: true,
    VDS: true,
    VDI: true,
    VDT: true,
};

Consts.ValueTypes = {
    MBC: I18N.TR('Coil'),
    MBR: I18N.TR('Register'),
    MBD: I18N.TR('Discrete Input'),
    MBI: I18N.TR('Input Register'),
    SCR: I18N.TR('Berechneter Wert'),
    UNSPECIFIED: I18N.TR('UNSPECIFIED'),
    VDC: I18N.TR('Virtuelles Coil'),
    VDR: I18N.TR('Virtuelles Register'),
    VDS: I18N.TR('Virtueller berechneter Wert'),
    VDI: I18N.TR('Virtuelles Input Register'),
    VDT: I18N.TR('Virtueller Discrete Input'),
    WD: I18N.TR('Wetterdaten'),
};

module.exports = Consts;
